<!-- <template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card
            width="80"
            height="75"
            :to="`/auth?appsToken=${user.apps_token}`"
            class="pa-2 box-shadow ma-1"
            style="border-radius: 10px;">
            <v-img 
              width="40"
              height="auto"
              alt="kominfo" 
              :src="$store.state.user.apps_icon_url"
              class="ma-auto">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    :color="`#000`">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>

            <div 
              class="text-center one-line mt-2"
              style="font-size: 8px; opacity: 40%;">
              Link APP
            </div>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        menu: [
          {
            text: 'Profil Saya',
            icon: 'mdi-account-reactivate-outline',
            link: '/profile?menu=profile'
          },
          {
            text: 'Password',
            icon: 'mdi-lock-reset',
            link: '/profile?menu=password'
          }
        ],

        form: {},

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      General: () => import(/* webpackPrefetch: true */ '@/components/profile/general.vue'),
      Password: () => import(/* webpackPrefetch: true */ '@/components/profile/password.vue')
    },
    watch: {
      '$route.query.menu': function(val) {
        this.changeLink(val)
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    beforeMount () {
      this.changeLink(this.$route.query.menu)
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        await get(`admin/profile_user/detail`)
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.form = res.results.data}
        })
      },

      changeLink (query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          this.selected.menu = query === 'profile' ? 0 : 1
        }
      },
      changeQuery (link) {
        this.$router.push(link)
      }
    }
  }
</script> -->


<template>
  <div style="background-color: #fff; height: 100%;">
    <v-container class="fill-height justify-center">
      <v-app-bar color="#fff" fixed nav elevation="0" app>
        <v-spacer></v-spacer>
        <div>
          <div class="caption text-right">{{ user.name }}</div>
          <div class="caption text-right">{{ user.email }}</div>
        </div>
        <v-menu
          close-on-content-click
          max-width="350"
          :nudge-bottom="10"
          offset-y
          rounded="lg"
          max-height="450"
          allow-overflow
        >
          <template v-slot:activator="{ on: onMenu }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: onTooltip }">
                <v-btn icon v-on="{ ...onMenu, ...onTooltip }" class="mx-1">
                  <v-avatar>
                    <v-img
                      :src="
                        user.image_url !== ''
                          ? user.image_url
                          : require('@/assets/image/member_default.png')
                      "
                    ></v-img>
                  </v-avatar>
                </v-btn>
              </template>
              <div class="caption font-weight-bold">Akun</div>
              <div class="caption">{{ user.name }}</div>
              <div class="caption">{{ user.email }}</div>
            </v-tooltip>
          </template>
  
          <v-card width="350">
            <v-card-text class="text-center">
              <v-avatar size="80">
                <v-img
                  :src="
                    user.image_url !== ''
                      ? user.image_url
                      : require('@/assets/image/member_default.png')
                  "
                ></v-img>
              </v-avatar>
              <div class="mt-4 subtitle-1">{{ user.name }}</div>
              <div class="mb-4 caption">{{ user.email }}</div>
              <v-divider></v-divider>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                class="mb-4 text-none"
                depressed
                outlined
                :color="set_color"
                @click="logout"
                >Keluar dari aplikasi</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-app-bar>
      <div class="d-flex justify-center align-center">
        <v-card elevation="0">
          <v-card-text>
            <v-row class="justify-space-between align-center">
              <v-col cols="12" md="2" v-for="(item, index) in user.apps" :key="index">
                <v-hover v-slot="{ hover }">
                  <v-card min-width="180" :href="`${item.apps_link_url}?p=${item.apps_token}&q=${token}`" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                    <v-card-title class="justify-center">
                      <v-avatar size="100">
                        <v-img :src="item.apps_icon_url"></v-img>
                      </v-avatar>
                    </v-card-title>
                    <v-card-text class="text-center subtitle-2">
                      {{ item.apps_name }}
                    </v-card-text>
                  </v-card>
                </v-hover>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
export default {
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },

    rps () {
      return this.$vuetify.breakpoint.name
    },
    isDay () {
      let hours = (new Date()).getHours(),
          day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
      return day
    },
    set_color () {
      return this.$store.state.color
    },
    set_color_rgb () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g}, ${b}, 0.97)`
    },
    set_color_rgb_up () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
    },
    set_color_rgb_down () {
      let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

      return `rgba(${r}, ${g}, ${b}, 0.25)`
    }
  },

  

  methods: {
    logout() {
      TokenService.removeToken();
      window.location = "/login";
    },
  },
};
</script>

<style>
</style>